<div class="flex items-center" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <h2 *ngIf="!form?.get('name')?.value" class="headline m-0 flex-auto">Nuevo CRV</h2>

  <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
    <mat-icon svgIcon="mat:close"></mat-icon>
  </button>
</div>
  
<form [formGroup]="form">
  <div class="flex flex-col sm:flex-row">
    <mat-form-field *ngIf="this.documentType == ''" class="sm:mr-6 flex-auto">
      <mat-label appearance="fill"> Expediente </mat-label>
          <input class="border-0 outline-none w-full bg-transparent" type="text" [dynamicWidth]="{ minWidth: 50, maxWidth: 200 }"
            [required]="requiredReference" placeholder="Seleccionar expediente" matInput
            aria-label="Number" [matAutocomplete]="autoModel"
            formControlName="referenceName"
            (input)="SearchWeightuggestions($event.target.value)">
        <mat-autocomplete (optionSelected)="loadTypeOptions()" showPanel="true" (optionsScroll)="onScroll()" 
        #autoModel="matAutocomplete" panelWidth="auto" showPanel="true" [displayWith]="displayFn"
          class="mat-select-panel flex-auto">
          <mat-option *ngFor="let item of filteredOptions | async" [value]="item.name">
            {{item.name}}
          </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="flex-auto">
      <mat-label>CMR</mat-label>
      <mat-select formControlName="cmr" (valueChange)="onCMRChange($event)">
        <mat-option *ngFor="let doc of this.CRVdata?.documents" [value]="doc">
          <div *ngIf="doc.hasCRV" class="text-gray-500">
            <mat-checkbox type="checkbox" [checked]="doc.hasCRV" (click)="$event.preventDefault()" color="primary"></mat-checkbox>
             {{ doc.name }}</div>
          <div *ngIf="!doc.hasCRV">
            <mat-checkbox type="checkbox" [checked]="doc.hasCRV" (click)="$event.preventDefault()" color="primary"></mat-checkbox>
             {{ doc.name }}</div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
    
  <div class="flex flex-col sm:flex-row">
    <mat-form-field class="flex-auto min-w-[300px]">
      <mat-label>Comercial</mat-label>
      <input formControlName="userReceiver" matInput>
    </mat-form-field>
    <mat-form-field class="sm:ml-6 flex-auto min-w-[300px]">
      <mat-label>Destinatario</mat-label>
      <ng-container *ngIf="this.receiver.length > 0">
        <input type="text" matInput formControlName="entityReceiver"
          [matAutocomplete]="autoContacts" placeholder="Seleccionar destinatario" (change)="isValid()">
        <mat-autocomplete #autoContacts="matAutocomplete" (optionSelected)="onContactChange($event.option.value)">
          <mat-option *ngFor="let entity of this.receiver" [value]="entity.email">
            {{ entity.email }}
          </mat-option>
        </mat-autocomplete>
      </ng-container>
      <ng-container *ngIf="this.receiver.length == 0">
          <input type="text" matInput formControlName="entityReceiver"
            placeholder="Seleccionar destinatario" (change)="isValid()">
        </ng-container>
    </mat-form-field>
    <span class="sm:ml-3 flex items-center">
      <mat-checkbox *ngIf="this.CRVdata?.brokers.length > 0" formControlName="sendBroker" color="primary" (change)="onCheckboxChange()">
        Enviar a broker
      </mat-checkbox>
    </span>
  </div>
  
  <div *ngIf="hasTract == false" class="flex flex-col sm:flex-row">
    <mat-form-field class="flex-auto">
      <mat-label>Lugar de carga</mat-label>
      <mat-select formControlName="loadingLocation">
        <mat-option *ngFor="let location of this.CRVdata?.loadingLocations" [value]="location">
          {{ location.address }}, {{ location.town }}, {{ location.postalCode }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="sm:ml-6 flex-auto">
      <mat-label>Lugar de descarga</mat-label>
      <mat-select formControlName="unloadingLocation">
        <mat-option *ngFor="let location of this.CRVdata?.unloadingLocations" [value]="location">
          {{ location.address }}, {{ location.town }}, {{ location.postalCode }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  
  <div *ngIf="hasTract == false" class="flex flex-col sm:flex-row">
    <mat-form-field class="flex-auto">
      <mat-label>Empresa de transporte</mat-label>
      <mat-select formControlName="entityTransport">
        <mat-option *ngFor="let entity of this.CRVdata?.transport" [value]="entity">
          {{ entity.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="sm:ml-6 flex-auto">
      <mat-label>Fecha recogida</mat-label>
      <input matInput formControlName="loadingDate" [matDatepicker]="picker1">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="sm:ml-6 flex-auto">
      <mat-label>Fecha entrega</mat-label>
      <input matInput formControlName="unloadingDate" [matDatepicker]="picker2">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>
  
  <div *ngIf="hasTract == false" class="flex flex-col sm:flex-row">
    <mat-form-field class="flex-auto">
      <mat-label>Conductor</mat-label>
      <input formControlName="driverName" matInput>
    </mat-form-field>  
    <mat-form-field class="sm:ml-6 flex-auto">
      <mat-label>Matrícula</mat-label>
      <input formControlName="truckPlate" matInput>  
    </mat-form-field>
  </div>
</form>

<!-- <ng-container *ngIf="hasVehicles();">
  <div class="mb-2">
    <div class="my-2">
      <span class="uppercase font-normal text-gray-500 text-left">Vehículos</span>
    </div>
    <ng-container *ngFor="let vehicle of this.form.get('cmr').value.vehicles">
      <div class="w-full">{{ vehicle.vin }} - {{ vehicle.plate }} - {{ vehicle.version }} - {{ vehicle.model }}</div>
    </ng-container>
  </div>
</ng-container> -->
  
<mat-dialog-actions align="end">
  <button color="primary" mat-flat-button type="button" (click)="save(true)" [disabled]="!form.valid || isSigned || saving">
    <mat-icon class="mr-2" svgIcon="mat:open_in_new"></mat-icon>
    Previsualizar
  </button>
  <button class="ml-4 flex-none" color="primary" mat-flat-button type="button" (click)="send()" [disabled]="!form.valid || !isValid() || isSigned || saving">
    <mat-icon class="mr-2" svgIcon="mat:send"></mat-icon>
    Generar y enviar
  </button>
  <button color="primary" mat-flat-button type="button" (click)="save(false)" [disabled]="!form.valid || !isValid() || isSigned || saving">
    <mat-icon class="mr-2" svgIcon="mat:save"></mat-icon>
    Generar
  </button>
</mat-dialog-actions>